import { useEffect, useState } from "react"
import { GTBClassification } from "../../../helpers/interfaces"
import { FormEditMode } from "../../../helpers/constants"
import { createGTBClassification, updateGTBClassification } from "../../../apiServices/GTBMappingKeysApi"
import CustomDialog from "../../CustomDialog"
import { CustomTextField } from "../../../layouts/themes"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"


interface Props {
    setGTBClassification:React.Dispatch<React.SetStateAction<GTBClassification[]>>
    gtbClassification: GTBClassification[]
    openGTBClassificationForm:boolean
    setFormEditMode:  React.Dispatch<React.SetStateAction<number>>
    setOpenGTBClassificationForm:React.Dispatch<React.SetStateAction<boolean>>
    gtbClassificationToEdit:string
    gtbClassificationEditMode:number
}
function CreateEditGTBClassification(props: Props) {
    const [gtbClassificationName, setGTBClassificationName] = useState<string>("");
    
    useEffect(() => {
        if (props.gtbClassificationEditMode === FormEditMode.EDIT) {
            var _gtbClassificationName = props.gtbClassification.find(e => e.id === props.gtbClassificationToEdit)
            if (!_gtbClassificationName) return
            setGTBClassificationName(_gtbClassificationName.name)
           
        }
    }, [props.gtbClassification, props.gtbClassificationEditMode, props.gtbClassificationToEdit])

    function createNewGTBClassification() {
        createGTBClassification(gtbClassificationName).then(_gtb=> {
            props.setOpenGTBClassificationForm(false);
            props.setGTBClassification(gtb => [...gtb, _gtb])
            
        })
    }
    function updateNewGTBClassification() {
        updateGTBClassification(props.gtbClassificationToEdit, gtbClassificationName).then(result => {
            props.setOpenGTBClassificationForm(false);
            props.setGTBClassification(gtb => gtb.map(a=> a.id === props.gtbClassificationToEdit ? result: a))
           
        })
    }
    return (
        <>
        <CustomDialog dialogTitle={props.gtbClassificationEditMode === FormEditMode.CREATE ? 'Add New Classification ' : 'Update Classification '} setOpenDialog={props.setOpenGTBClassificationForm} openDialog={props.openGTBClassificationForm}>
            <form>
                <div >
                    <label className='title-label'>Classification Name <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="Classification Name" value={gtbClassificationName} onChange={(e) => setGTBClassificationName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
               

                <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                    <Button disabled={!gtbClassificationName} variant="contained" color='secondary' onClick={props.gtbClassificationEditMode === FormEditMode.CREATE ? createNewGTBClassification : updateNewGTBClassification} >
                        <Add />&nbsp; {props.gtbClassificationEditMode === FormEditMode.CREATE ? 'Add New Classification' : 'Update Classification'}
                    </Button>
                </div>
            </form >


        </CustomDialog>

    </>
    )
}
export default CreateEditGTBClassification